export const QUESTIONNAIRE_POSITION_KEY = 'sf_lq_position'
export const QUESTIONNAIRE_CHOICES_KEY = 'sf_lq_choices'
export const QUESTIONNAIRE_BOOKS_KEY = 'sf_lq_books'
